module.exports = __webpack_public_path__ + "media/wyposazenie/bezpieczenstwo-b81c05fb.png";